export const dedtailList = [
  {
    name: 'EQUIPTOP',
    time: '1988年',
    prods: '精密平面磨床、CNC平面磨床、CNC立式综合加工中心机、五轴立式加工中心等',
    customs: '航天、3C电子、光电等产业',
    etime: '1988',
    eprods: 'Precision Surface Grinder, CNC Surface Grinder, CNC Vertical Machining Center, Five Axes Vertical Machining Center, etc',
    ecustoms: 'Aerospace, 3C electronics and Optoelectronics Industry.',
    logoSrc: '/logos/EQUIPTOP.png' ,
    videoSrc:'EQUIPTOP.mp4',
    banner: ['EQUIPTOP.jpg'],
  },
  {
    name: 'FEELER',
    time: '1979年',
    prods: '立/卧式加工中心、高端五轴立式加工中心/铣车复合机、客制自动化生产线等',
    customs: '汽车、航天、电子医疗、模具、精密加工等产业',
    etime: '1979',
    eprods: ' Vertical/Horizontal Machining Center, High Accuracy Five-Axis Vertical Machining Center/Multi-Tasking Machine, Customized Automated Production Line, etc.',
    ecustoms: 'Automotive, Aerospace, Electronics Medical, Mold, Precision Machining, etc.',
    logoSrc: '/logos/FEELER.png' ,
    videoSrc:'FEELER.webm',
    banner: ['feeler.jpg'],
  },
  {
    name: 'LEADWELL',
    time: '1980年',
    prods: '立式/卧式/五轴加工中心、卧式车床、高端车铣复合机、自动化生产线等',
    customs: '汽车、航天、医疗、水五金、重工、电子等产业',
    etime: '1980',
    eprods: 'Vertical/Horizontal/5 Axes Machining Center, Horizontal Turning Center, High Accuracy Multi-Tasking Machine, Automation Production Line Plan, and so on.',
    ecustoms: 'Automotive, Aerospace, Medical, Plumbing industry (Faucet Kits), Heavy Cutting, Electronics, etc.',
    logoSrc: '/logos/LEADWELL.png' ,
    videoSrc:'LEADWELL.mp4',
    banner: ['LEADWELL.jpg'],
  },
  {
    name: 'SANCO',
    time: '1981年',
    prods: 'CNC龙门加工心机(五面体加工中心、五轴加工中心)、CNC卧式镗铣床等中大型高精密设备等',
    customs: '汽车、轨道、航天、能源、重工、电子等产业',
    etime: '1981',
    eprods: ' CNC Gantry Machining Center (Pentahedron Machining Center, Five-Axis Machining Center), CNC Horizontal Boring and Milling Machines and other Medium and Large-Scale High-Precision Equipment, etc.',
    ecustoms: 'Automotive, Rail, Aerospace, Energy, Heavy industry, Electronics, etc.',
    logoSrc: '/logos/SANCO.png' ,
    videoSrc:'',
    banner: ['ECOCASANCO.jpg'],
  },
  {
    name: 'ECOCA',
    time: '1980年',
    prods: '高速车床、CNC车床、CNC车铣复合机等',
    customs: '汽车、油能、工程机械等产业',
    etime: '1980',
    eprods: ' High Speed Precision Lathe, CNC Lathe, CNC Milling-Turning Compound Machine, etc.',
    ecustoms: 'Automobile, Oil and Gas, Construction Machine Industry, etc.',
    logoSrc: '/logos/ECOCA.png' ,
    videoSrc:'',
    banner: ['ECOCASANCO.jpg'],
  },
  {
    name: 'SNK NISSSIN',
    time: '1952年',
    prods: '立式五轴加工机、卧式车床、立式磨床等',
    customs: '汽车、船舶、钢铁、一般零件等产业',
    etime: '1952',
    eprods: 'Five-Axis Vertical Machining Center, Horizontal Turning Center, Vertical Grinder, etc.',
    ecustoms: 'Automotive, Shipbuilding, Steel, General Parts, etc.',
    logoSrc: '/logos/NISSIN.png' ,
    videoSrc:'NISSIN.mp4',
    banner: ['SNK1.jpg', 'SNK2.jpg'],
  },{
    name: 'TAISEI',
    time: '2006年',
    prods: '立式磨削加工中心、立式磨床、卧式内圆磨床等',
    customs: '汽车、齿轮、机器人、一般零件加工等产业',
    etime: '2006',
    eprods: 'Vertical Grinding Center, Vertical Grinder, Horizontal Internal Grinder, etc.',
    ecustoms: 'Automotive, Gear, Robot, General Parts, etc.',
    logoSrc: '/logos/TAISEI.png' ,
    videoSrc:'',
    banner: ['taisei.jpg'],
  },
  {
    name: 'F.T.',
    time: '2008年',
    prods: 'FT-Japan为台湾友嘉与日本高松机械的合资公司，主要销售台湾友嘉集团机台为主，包含立/卧式加工中心机等',
    customs: '汽车、航天、电子工业、印刷设备等产业',
    etime: '2008',
    eprods: 'FT-Japan is a joint venture between Taiwan FFG and Japan’s Takamatsu Machinery. It mainly sells Taiwan FFG machines, including vertical/horizontal machining centers, etc.',
    ecustoms: 'Automotive, Aerospace, Electronics , Printing Equipment, etc.',
    logoSrc: '/logos/FT.png',
    videoSrc:'',
    banner: ['FT.jpg'],
  },
  {
    name: 'IKEGAI',
    time: '1889年，品牌历史达133年，亚洲(含日本)历史最久的工具机品牌',
    prods: '大型CNC车床、塑料注塑成型机械、发动机制造、珩磨加工中心机等',
    customs: '航天、轨道运输、发动机等产业', 
    noDesc: '日本第一台车床制造商',
    etime: '1889, 133 years. The oldest machine tool brand in Japan and Asia.',
    eprods: 'Large CNC lathes, Plastic Injection Molding Machinery, Engine Manufacturing, Honing Machining Centers, etc.',
    ecustoms: 'Industry: Aerospace, Rail Road, Engine, etc.',
    enoDesc: '日本第一台车床制造商',
    logoSrc: '/logos/IKEGAI.png',
    videoSrc:'IKEGAI.webm',
    banner: ['IKEGAI.jpg'],
  },
  {
    name: 'TAKAMAZ-FEELER',
    time: '1961年',
    prods: '精密车床、复合式车床、高自动化生产线等',
    customs: '汽车、航空、航天、电子等产业', 
    etime: '1961',
    eprods: 'Precision Turning Center, Multi-Tasking Turning Center, Automated Production Line, etc.',
    ecustoms: 'Automotive, Aerospace, Electronics, etc.',
    logoSrc: '/logos/TAKAMAZFEELER.png',
    videoSrc:'',
    banner: ['TAKAMAZ.jpg'],
  },
  {
    name: 'SNK',
    time: '1898年，品牌历史达124年',
    prods: '高速轮廓加工中心、卧式五轴轮廓加工中心、五轴高速轮廓加工中心等',
    customs: '航天、航空、汽车、钢铁、造船等产业',
    noDesc: '日本最高的东京晴空塔采用了SNK离心力铸造管',
    etime: '1898, 124 years.',
    eprods: 'High-Speed Contour Machining Center, Horizontal Five-Axis Contour Machining Center, Five-Axis High-Speed Contour Machining Center, etc.',
    ecustoms: 'Aerospace, Automotive, Steel, Shipbuilding, etc.',
    enoDesc: 'SNK centrifugal cast steel product was adopted as constructional material of Tokyo Sky Tree',
    logoSrc: '/logos/SNK.png',
    videoSrc:'SNK.mp4',
    banner: ['SNK1.jpg', 'SNK2.jpg'],
  },
  {
    name: 'Mectron-FEELER',
    time: '1929年',
    prods: '加工中心机、CNC钻床、钻孔攻牙机、自动化生产系统等',
    customs: '汽车、电子等产业',
    etime: '1929',
    eprods: 'Machining Center, CNC Drilling Machine, Tapping Center, Automated Production System, etc.',
    ecustoms: 'Automotive, Electronics, etc.',
    logoSrc: '/logos/MECTRONFEELER.png',
    videoSrc:'',
    banner: ['mectron.jpg'],
  },
  {
    name: 'WAIDA FEELER',
    time: '1933年',
    prods: '全自动刀片周边磨床、全自动刀片沟槽/刄口磨床、光学曲线磨床、智能坐标磨床等',
    customs: '舍弃式刀片、切削刀具、光学、精密模具、汽车、航天等产业',
    etime: '1933',
    eprods: ' Fully Automatic Insert Periphery Grinder, Fully Automatic Grooving Insert Grinder, Fully Automatic Profile Grinder, Fully Automatic Intelligent Jig Grinder',
    ecustoms: 'Insert, Tool, Optical, High precision mold, Automotive, Aerospace, etc.',
    logoSrc: '/logos/WAIDAZFEELER.png',
    videoSrc:'WAIDA.mp4',
    banner: ['WAIDA.jpg'],
  },
  {
    name: 'SIGMA',
    time: '1950年',
    prods: '三轴 / 五轴立式加工中心、托盘式立式加工中心等',
    customs: '汽车、航空、精密机械及医疗器械等产业',
    etime: '1950',
    eprods: 'Three - Axis / Five - Axis Vertical Machining Center, Vertical Machining Center, etc.',
    ecustoms: 'Automotive, Aerospace, Precision Machinery, Medical Machinery, etc.',
    logoSrc: '/logos/SIGMA.png',
    videoSrc:'Sigma.mp4',
    banner: ['JOBS.jpg'],
  },
  {
    name: 'SEC',
    time: '1922年，品牌历史达100年',
    prods: '数控雕刻机、餐具抛光机、雕刻机刀具、自动化生产线等',
    customs: '电子、汽车等产业',
    etime: '1922, 100 years.',
    eprods: 'CNC engraving machine, Tableware polishing machine, Engraving machine tool, Automated Production Line, etc.',
    ecustoms: 'Electronics, Automotive, etc.',
    logoSrc: '/logos/SEC.png',
    videoSrc:'',
    banner: ['SEC.jpg'],
  },
  {
    name: 'Takeuchi',
    time: '2002年',
    prods: '印刷线路板数控钻孔机、印刷线路板用外形加工机、印刷线路板用孔位测试仪、电器检查用精密钻孔机等',
    customs: '印刷线路板行业、电检行业等产业',
    etime: '2002',
    eprods: 'CNC drilling machine for printed circuit board, contour processing machine for PCB, hole position tester for PCB, precision drilling machine for electrical inspection, etc.',
    ecustoms: 'PCB industry, Electrical Inspection Industry, etc.',
    logoSrc: '/logos/TAKEUCHI.png',
    videoSrc:'',
    banner: ['Takeuchi.jpg'],
  },
  {
    name: 'DSK MACHINERY',
    time: '1995年',
    prods: '重型卧车、重型立车、重型龙门加工中心机、重型滚磨机等',
    customs: '发电、造船、轨道运输等重工业产业',
    etime: '1995.',
    eprods: 'Heavy-Duty Horizontal lathe, Heavy-Duty Vertical Lathe, Heavy-Duty Gantry Machining Center, Heavy-Duty Roller Mill, etc.',
    ecustoms: 'Power Generation, Shipbuilding, Rail Road, etc.',
    logoSrc: '/logos/DSK.png',
    videoSrc:'DSK.webm',
    banner: ['DMC.jpg'],
  },
  {
    name: 'DMC',
    time: '1944年，品牌历史达78年，韩国历史最久的工具机品牌',
    prods: 'CNC多轴车床、 双主轴立式加工中心机、钻孔攻牙机、自动化产线等',
    customs: '汽车、能源、精密模具等产业',
    etime: '1944, 78 years. The oldest machine tool brand in Korea.',
    eprods: 'CNC Multi-Spindle Turning Center, Duo Head Type Vertical Machining Center, Tapping Center, Automated Production Line, etc.',
    ecustoms: 'Automotive, Energy, Precision Mold, etc.',
    logoSrc: '/logos/DMC.png',
    videoSrc:'DMC.webm',
    banner: ['DMC.jpg'],
  },
  {
    name: 'Pfiffner',
    time: '1970年',
    prods: '转盘式多轴自动加工机、高阶多轴转盘加工中心机等',
    customs: '汽车 、航天、通讯电子、锁类、气压油压接头 、交钥匙工程等产业',
    etime: '1970',
    eprods: 'Rotary Transfer Machine, High - End Multi - Axis Turntable Machining Centers, etc.',
    ecustoms: 'Automotive, Aerospace, Communication, Key, Pneumatic and Hydraulic Connector, Turnkey Project, etc.',
    logoSrc: '/logos/PFIFFNER.png',
    videoSrc:'1-24.webm',
    banner: ['Pfiffner.jpg','Pfiffner1.jpg','Pfiffner2.jpg'],
  },
  {
    name: 'Cross Huller',
    time: '2005年',
    noDesc: '相关技术与产品已整合至德国MAG品牌下',
    prods: '',
    customs: '',
    etime: '2005',
    enoDesc: 'Related technologies and products have been integrated under the German MAG brand.',
    eprods: '',
    ecustoms: '',
    logoSrc: '/logos/CROSSHULLER.png',
    videoSrc:'',
    banner: [],
  },
  {
    name: 'SMS',
    time: '1854年，品牌历史达168年，美洲(含美国)历史最久的工具机品牌',
    prods: '双主轴立式车床、单主轴倒立式车床、汽车整厂自动生产线等',
    customs: '汽车、建设机械、自动化生产线等产业',
    etime: '1854, 168 years. The oldest machine tool brand in the Americas. (USA included)',
    eprods: 'Double-Spindle Vertical Lathe, Single-Spindle Inverted Lathe, Automatic Production Line of the Whole Automobile Factory, etc.',
    ecustoms: 'Automotive, Construction machinery, Automated Production Line, etc.',
    logoSrc: '/logos/SMS.png',
    videoSrc:'SMS.mp4',
    banner: ['SMS.jpg'],
  },
  {
    name: 'LAMB',
    time: '2005年',
    noDesc: '相关技术与产品已整合至德国MAG品牌下',
    prods: '',
    customs: '',
    etime: '2005',
    enoDesc: 'Related technologies and products have been integrated under the German MAG brand.',
    eprods: '',
    ecustoms: '',
    logoSrc: '/logos/LAMB.png',
    videoSrc:'',
    banner: [],
  },
  {
    name: 'IMAS',
    time: '1948年',
    prods: '多轴多任务站回转式加工中心机等',
    customs: '汽车、五金、一般零件加工等产业',
    etime: '1948',
    eprods: 'Multi - Station Rotary Machining Center, etc.',
    ecustoms: 'Automotive, Metal Parts, General Parts, etc.',
    logoSrc: '/logos/IMAS.png',
    videoSrc:'IMAS.mp4',
    banner: ['IMAS.jpg'],
  },
  {
    name: 'RAMBAUDI',
    time: '1945年',
    noDesc: '',
    prods: '高架桥式铣削中心、工作台移动式龙门铣削中心、动柱式强力铣削中心等',
    customs: '航空、航天、自动车工业、精密模具等产业',
    etime: '1945',
    enoDesc: '',
    eprods: 'Elevated Bridge Milling Center, Table Moving Gantry Milling Center, Moving Column Powerful Milling Center, etc.',
    ecustoms: 'Aerospace, Automotive, Precision Mold, etc.',
    logoSrc: '/logos/RAMBAUDI.png',
    videoSrc:'Rambaudi.mp4',
    banner: ['Rambaudi.jpg'],
  },
  {
    name: 'Meccanodora',
    time: '1961年',
    prods: '三销轴高速磨床(插入式接头)、球笼磨床(传动轴接头)、车铣磨多任务复合工具机等',
    customs: '汽车、滚子轴承和家用电器行业开发和制造优质高效的磨床',
    etime: '1961',
    eprods: 'Three - Pin High - Speed Grinder (plug -in joint), Ball Cage Grinder(drive shaft joint), Turning, Milling and Grinding Multi - Tasking Compound Machine Tool, etc.',
    ecustoms: 'Automotive, Roller Bearing, home appliance industry development and manufacture of high - quality and efficient grinding machines.',
    logoSrc: '/logos/MECCANODORA.png',
    videoSrc:'MORARA.mp4',
    banner: ['TACCHELLA.jpg'],
  },
  {
    name: 'MORARA',
    time: '1919年，品牌历史达103年',
    noDesc: '',
    prods: '轨道车轴外圈磨床、内圆磨床等',
    customs: '航空、轨道运输等产业',
    etime: '1919, 103 years.',
    enoDesc: '',
    eprods: 'Rail Axle Cylindrical Grinder, Internal Grinder, etc.',
    ecustoms: 'Aerospace, Rail Road, etc.',
    logoSrc: '/logos/MORARA.png',
    videoSrc:'MORARA.mp4',
    banner: ['MORARA.jpg'],
  },
  {
    name: 'MAG',
    time: '2005年',
    prods: '立式/卧式车削加工中心、弹性/敏捷制造系统、自动化周边等',
    customs: '汽车、航天、电子等产业',
    noDesc: '发动机、变速箱两大项目全球市场占比超过30%，曲轴等传动件市占约35%，齿轮逾20%，汽车模具更是全球前三大供货商知名客户涵括奔驰、BMW、法拉利、劳斯莱斯等顶级汽车厂',
    etime: '2005',
    eprods: 'Vertical/Horizontal Turning Machining Centers, Flexible/Agile.',
    ecustoms: 'Automotive, Aerospace, Electronics, etc.',
    enoDesc: 'The two major projects of engine and transmission account for more than 30% of the global market, crankshafts and other transmission parts account for about 35%, and gears exceed 20%.Auto molds are the top three suppliers in the world.Famous Customer: Benz, BMW, Ferrari, Rolls- Royce, etc.',
    logoSrc: '/logos/MAG.png',
    videoSrc:'MAG.mp4',
    banner: ['MAG.jpg','MAG1.jpg','MAG2.jpg','MAG3.jpg','MAG4.jpg','MAG5.jpg','MAG6.jpg'],
  },
  {
    name: 'HESSAPP',
    time: '1946年',
    noDesc: '',
    prods: '拾取式立式车床、双主轴倒 + 正立式传送车床、立式车床等',
    customs: '汽车、能源、模具、航天、航空、电子工业等产业',
    etime: '1946',
    enoDesc: '',
    eprods: 'Pick - up Vertical Lathe, Double - Spindle Inverted & Vertical Transfer Lathe, Vertical Turning Center, etc.',
    ecustoms: 'Automotive, Energy, Mold, Aerospace, Electronics, etc.',
    logoSrc: '/logos/HESSAPP.png',
    videoSrc:'HESSAPP.mp4',
    banner: ['Hessapp.jpg'],
  },
  {
    name: 'VDFBOEHRINGER',
    time: '1844年，品牌历史达178年',
    prods: '卧式车削及车 / 铣加工中心、曲轴加工中心、自动化设备与技术服务等',
    customs: '汽车自动化生产线、发电设备、电子、铁路等产业',
    noDesc: '',
    etime: '1844, 178 years.',
    eprods: 'Horizontal Turning and Turning / Milling Machining Centers, Crankshaft Machines, Automation Equipment and Technical Services, etc.',
    ecustoms: 'Automotive Automated Production Line, Power Equipment, Electronics, Rail Road, etc.',
    enoDesc: '',
    logoSrc: '/logos/VDF.png' ,
    videoSrc:'VDF.webm',
    banner: ['VDF.jpg'],
  },
  {
    name: 'MODUL',
    time: '1900年，品牌历史达122年',
    noDesc: '',
    prods: '齿轮成型机、齿轮研磨机、齿轮倒角机、滚齿机等',
    customs: '汽车、传动系统、机械人等产业',
    etime: '1900, 122 years.',
    enoDesc: '',
    eprods: 'Gear Forming Machine, Gear Grinding Machine, Gear Chamfering Machine, Gear Hobbing Machine, etc.',
    ecustoms: 'Automotive, Transmission system, Robot, etc.',
    logoSrc: '/logos/MODUL.png',
    videoSrc:'Modul.mp4',
    banner: ['Modul.jpg'],
  },
  {
    name: 'EXCELLO',
    time: '2006年',
    prods: '',
    customs: '',
    noDesc: '相关技术与产品已整合至德国MAG品牌下',
    etime: '2006',
    eprods: '',
    ecustoms: '',
    enoDesc: 'Related technologies and products have been integrated under the German MAG brand.',
    logoSrc: '/logos/EXCELLO.png',
    videoSrc:'',
    banner: [],
  },
  {
    name: 'JOBS',
    time: '1978年',
    noDesc: '',
    prods: '直线电机高架桥式铣削中心、高速龙门 & 高架桥式铣削中心、龙门式强力铣削中心等',
    customs: '航天、航空、汽车、能源、模具等产业/知名客户涵括BOEING、AIRBUS、BMW等',
    etime: '1978',
    enoDesc: '',
    eprods: 'Linear Motor Overhead Milling Center, High Speed Gantry & Overhead Milling Center, Gantry Power Milling Center, etc.',
    ecustoms: 'Aerospace, Automotive, Energy, Mold, etc./Famous Customers: BOEING, AIRBUS, BMW, etc.',
    logoSrc: '/logos/JOBS.png',
    videoSrc:'JOBS.mp4',
    banner: ['JOBS.jpg'],
  },
  {
    name: 'WITZIG FRANK',
    time: '1865年，品牌历史达157年',
    prods: '卧式回转传送机台、多任务站五轴加工中心、自动化设备与技术方案等',
    customs: '汽车生产线、航天、航空、电子等产业',
    noDesc: '多轴车床为全球市场占有率第一',
    etime: '1865, 157 years.',
    eprods: 'Horizontal Rotary Conveyor, Multi - Station Five - Axis Machining Center, Automation Equipment and Technical Solutions, etc.',
    ecustoms: 'Automotive Automated Production Line, Aerospace, Electronics, etc.',
    enoDesc: 'Multi - spindle lathe ranked first in the global market.',
    logoSrc: '/logos/WITZIGFRANK.png',
    videoSrc:'Witzig.mp4',
    banner: [],
  },
  {
    name: 'Honsberg',
    time: '1798年，品牌历史达224年，全球历史最久的工具机品牌',
    noDesc: '相关技术与产品已整合至德国MAG品牌下',
    prods: '',
    customs: '',
    etime: '1798, 224 years.The oldest machine tool brand in Germany.Europe, and Worldwide.',
    enoDesc: 'Related technologies and products have been integrated under the German MAG brand.',
    eprods: '',
    ecustoms: '',
    logoSrc: '/logos/HONSBERG.png',
    videoSrc:'',
    banner: [],
  },
  {
    name: 'SACHMAN',
    time: '1962年',
    prods: 'T型卧式镗铣加工中心、卧式动柱加工中心、立式移动式铣削中心等',
    customs: '航空、航天、汽车、能源等产业',
    noDesc: '',
    etime: '1962',
    eprods: 'T - Type Horizontal Boring and Milling Machining Center, Horizontal Column Type Machining Center, Vertical Mobile Milling Centers, etc.',
    ecustoms: 'Aerospace, Automotive, Energy, etc.',
    enoDesc: '',
    logoSrc: '/logos/SACHMAN.png',
    videoSrc:'Sachman.mp4',
    banner: ['Sachman.jpg'],
  },
  {
    name: 'TACCHELLA',
    time: '1921年，品牌历史达101年',
    noDesc: '',
    prods: '轨道车轴外圈磨床、内圆磨床、万能磨床等',
    customs: '汽车、精密机械等产业',
    etime: '1919, 103 years.',
    enoDesc: '',
    eprods: 'Rail Axle Cylindrical Grinder, Internal Grinder, etc.',
    ecustoms: 'Automotive, Precision Machinery, etc.',
    logoSrc: '/logos/TACCHELLA.png',
    videoSrc:'MORARA.mp4',
    banner: ['MORARA.jpg'],
  }

]